import React from "react";
import './ContainerButton.scss'
const ContainerButton = ( {  style, onClick, title, disabled }) =>
{

    return (
        <div className='container-button'>
            <button disabled={disabled} className="btn btn-icon btn-icon-left btn-small" style={style} onClick={onClick}><i className="et-arrow-bold-left"/>{ title }</button>
        </div>
    );
}

export default ContainerButton ;
